import React from "react";

const Washing_36 = React.forwardRef(
  ({ width = "43", height = "41", viewBox = "0 0 43 41", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5439 2H35.1867V8.78634C34.7504 8.75618 34.1797 8.72138 33.4653 8.68666C31.5395 8.59307 28.5686 8.5 24.3682 8.5C16.0132 8.5 11.5615 9.46668 8.77718 13.4246C7.45424 15.3052 6.56513 17.6758 6.00983 19.5249C5.72935 20.4588 5.52826 21.2797 5.397 21.8683C5.3313 22.1629 5.28292 22.4002 5.2507 22.5653C5.23458 22.6479 5.22249 22.7125 5.21429 22.7573L5.20489 22.8094L5.20233 22.8239L5.2012 22.8305L5.16802 23.0233L0.808433 21.1938L0 23.0293L12.1849 28.1428L10.6159 34.3642L0.0726881 38.9063L0.897597 40.7341L21.2724 31.9566L41.7264 40.5404L42.5349 38.7049L31.8344 34.2143L30.2979 28.0683L42.4622 22.8279L41.6373 21L37.1867 22.9173V0H11.5439V2ZM34.6736 24H29.2808L29.8051 26.0974L34.6736 24ZM27.944 26.8992L27.2192 24H15.2923L14.546 26.959L21.2625 29.7776L27.944 26.8992ZM14.0501 28.9256L12.9299 33.3673L18.7053 30.8792L14.0501 28.9256ZM12.6808 26.1762L13.2296 24H7.49528L12.6808 26.1762ZM28.4368 28.8701L23.8296 30.8549L29.5312 33.2477L28.4368 28.8701ZM6.18672 23L5.2012 22.8305C5.20116 22.8307 5.2012 22.8305 6.18672 23ZM33.3682 10.6843C34.1487 10.7222 34.7505 10.7601 35.1867 10.7913V22H7.41843C7.53942 21.4828 7.70682 20.8277 7.92532 20.1001C8.45865 18.3242 9.27372 16.1948 10.413 14.5754C12.553 11.5333 15.9804 10.5 24.3682 10.5C28.5393 10.5 31.4776 10.5924 33.3682 10.6843Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_36;
